import { Badge } from '@BICE_Vida/scp-components';
import Image from 'next/image';
import styles from './AdditionalCoverages.module.scss';

type AdditionalCoveragesT = {
  id: string;
  icon: string;
  iconBrackground: string;
  label: {
    text: string;
    color: string;
    background: string;
  };
  title: string;
  subtitle: string;
  onClick: (router?: any) => void;
  alt: string;
};

const AdditionalCoveragesCard = (card: AdditionalCoveragesT) => {
  return (
    <div key={card.id} className={styles.additional_coverages_card_container}>
      <div className={styles.additional_coverages_card}>
        <div className={styles.additional_coverages_card_img_container}>
          <div
            className={styles.additional_coverages_card_img}
            style={{ background: card.iconBrackground }}
          >
            <Image src={card.icon} alt={card.alt} width={50} height={50} />
          </div>
        </div>
        <Badge
          text={card.label.text}
          colorBg={card.label.background}
          colorText={card.label.color}
          className={styles.additional_coverages_card_badge}
        />
        <div className={styles.additional_coverages_card_title}>{card.title}</div>
        <div className={styles.additional_coverages_card_content}>
          <div className={styles.additional_coverages_card_description}>{card.subtitle}</div>
          <button className={styles.additional_coverages_card_button_detail} onClick={card.onClick}>
            Ver detalles
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdditionalCoveragesCard;
